// NOTE:
// This module intentionally stores product association IDs in a Set for fast lookup.
// It is expected to be populated once at app startup and treated as read-only.
// Do NOT mutate the Set directly (no .add/.delete/.clear) outside of this module.

const state = () => ({
  productAssociations: new Set(),
});

const getters = {
  hasId: (state) => (id) => state.productAssociations.has(id),
};

const mutations = {
  set: (state, associations = []) => {
    // Replace the Set reference to keep updates explicit.
    state.productAssociations = new Set(associations.map((item) => item.id));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
